const PROVINCE_ALIASES = [
  [/서울|seoul/i, '서울'],
  [/경기|gyeonggi/i, '경기'],
  [/인천|incheon/i, '인천'],
  [/부산|busan/i, '부산'],
  [/대구|daegu/i, '대구'],
  [/광주|gwangju/i, '광주'],
  [/대전|daejeon/i, '대전'],
  [/울산|ulsan/i, '울산'],
  [/세종|sejong/i, '세종'],
  [/강원|gangwon/i, '강원'],
  [/충북|충청북|chungcheongbuk|chungbuk/i, '충북'],
  [/충남|충청남|chungcheongnam|chungnam/i, '충남'],
  [/전북|전라북|jeollabuk|jeonbuk/i, '전북'],
  [/전남|전라남|jeollanam|jeonnam/i, '전남'],
  [/경북|경상북|gyeongsangbuk|gyeongbuk/i, '경북'],
  [/경남|경상남|gyeongsangnam|gyeongnam/i, '경남'],
  [/제주|jeju/i, '제주'],
];

const STATUS_LABELS = new Set([
  '기존 기록(미수집)',
  '주소지 확인 불가',
  '주소지 확인 오류',
  '주소지 정보 준비 중',
  '내부망',
  '해외 접속',
]);

export const getAuditKoreanProvince = (...values) => {
  const source = values.map((value) => String(value || '')).join(' ');
  return PROVINCE_ALIASES.find(([pattern]) => pattern.test(source))?.[1] || '';
};

export const getAuditLocationPresentation = (request = {}) => {
  const rawSummary = String(request.networkLocation || '').trim();
  const rawDetail = String(request.networkLocationDetail || rawSummary).trim();
  const fallback = rawSummary || rawDetail || '기존 기록(미수집)';
  if (STATUS_LABELS.has(fallback)) return { summary: fallback, detail: fallback };

  const province = getAuditKoreanProvince(rawSummary, rawDetail);
  if (!province) return { summary: '해외 접속', detail: '해외 접속' };
  const detailIsKorean = /[가-힣]/.test(rawDetail) && !/[A-Za-z]/.test(rawDetail);
  return {
    summary: province,
    detail: detailIsKorean ? rawDetail : province,
  };
};
